/*
 StudyRoom STUDY Uncle Julius' Study
 Pic Study
 InformOnEntry This is where Uncle Julius comes to write up his results after a long day in his laboratory.
 RoomFlag 2
 RoomScriptBox SAFE 209 26 73 80 SAFE Examine
 RoomScriptBox COMPUTER  25 158  56 61 COMPUTER Examine
 GoBox WORKSHOP 133 289 379 31 WORKSHOP Out
 RoomScriptBox FACREM 109 95 10 12 FACREM Take
 FrameSet FACREM study_fs 12 2 109 95
 */

function StudyRoom(game) {

    this.Room_constructor(game, 'study');
}

createjs.extend(StudyRoom, Room);

StudyRoom.prototype.preload =
    function () {
        this.manifest =
            this.makeManifest(this.id, [
                '#scene', 'facto-frames', 'safe-frames',
                {full_id: 'sound-take', full_src: 'sounds/oooh.wav'},
                {full_id: 'sound-look-closer', full_src: 'sounds/aaah.wav'},
                {full_id: 'sound-explain', full_src: 'sounds/hmmm.wav'}
            ]);

        this.Room_preload(this.manifest);
    };

StudyRoom.prototype.load =
    function () {
        this.Room_load();

        /* Audio */
        this.sndTake = this.world.queue.getResult('sound-take');
        this.sndLookCloser = this.world.queue.getResult('sound-look-closer');
        this.sndExplain = this.world.queue.getResult('sound-explain');

        /* Load shelf FactoPedia frames */
        this.loadFacto();

        /* Load safe frames */
        this.loadSafe();

        /* Computer, factopedia, safe, ByHouse */
        this.loadHitAreas();

        return this;
    };

StudyRoom.prototype.enter =
    function () {
        this.Room_enter(
            'This is where Uncle Julius comes to write up his results after a long day in his laboratory.'
        );

        this.areaRetreatClickListener = this.areaRetreat.on('click', function () { this.leave('byhouse'); }, this);
        this.areaSafeClickListener = this.areaSafe.on('click', this.examineSafe, this, 'safe');
        this.areaComputerClickListener = this.areaComputer.on('click', function () { this.leave('computer'); }, this);

        return this;
    };

StudyRoom.prototype.leave =
    function (nextKey) {
        this.areaRetreat.off(this.areaRetreatClickListener);
        this.areaSafe.off(this.areaSafeClickListener);
        this.areaComputer.off(this.areaComputerClickListener);

        this.Room_leave(nextKey);
    };

StudyRoom.prototype.next =
    function (nextKey) {
        if (typeof nextKey == 'object')
            nextKey = nextKey.nextkey;

        switch (nextKey) {
            case 'byhouse':
                return new ByHouseRoom(this.world);
            case 'safelock':
                return new GateLockRoom(this.world);
            case 'computer':
                return new HomeGateRoom(this.world);
        }

        // Bug detector
        return new TitleRoom(this.world);
    };

StudyRoom.prototype.loadHitAreas =
    function () {
        this.areaRetreat = this.makeHitRect(133, 289, 379, 31, 'byhouse', 'out');
        this.areaSafe = this.makeHitRect(209, 26, 73, 80, 'safe', 'examine');
        this.areaComputer = this.makeHitRect(25, 158,  56, 61, 'computer', 'examine');
        this.reg(this.areaRetreat);
        this.reg(this.areaSafe);
        this.reg(this.areaComputer);
    };

StudyRoom.prototype.loadFacto =
    function () {
        var artFactoFrameData = {
            images: [this.world.queue.getResult('study-facto-frames')],
            frames: {width: 10, height: 12, count: 2},
            animations: {present: 0, absent: 1}
        };

        this.artFactoFrames = new createjs.SpriteSheet(artFactoFrameData);
        this.artFacto = ujPut(new createjs.Sprite(this.artFactoFrames, 'present'), 109, 95, 'facto');
        this.artFacto.gameCursor = 'take';
        this.artFacto.on('click', this.takeFacto, this);
        this.reg(this.artFacto);
    };

StudyRoom.prototype.loadSafe =
    function () {
        var artSafeFrameData = {
            images: [this.world.queue.getResult('study-safe-frames')],
            frames: {width: 81, height: 90, count: 2},
            animations: {closed: 0, open: 1}
        };

        this.artSafeFrames = new createjs.SpriteSheet(artSafeFrameData);
        this.artSafe = ujPut(new createjs.Sprite(this.artSafeFrames, 'closed'), 200, 21, 'safe');
        this.reg(this.artSafe);
    };

StudyRoom.prototype.takeFacto =
    function () {
        console.log('Factopedia taken at ' + this.id);
    };

StudyRoom.prototype.examineSafe =
    function () {
        console.log('Examining safe at ' + this.id);
    };

createjs.promote(StudyRoom, 'Room');
